import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import { colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {closeAlert } from 'actions'
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
  message: {
    whiteSpace: 'pre-wrap',
    maxHeight: '90vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(0, 2),
    maxWidth: 720,
    margin: '0 auto'
  },
  contact: {
    margin: theme.spacing(3, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  }
}));

const CustomizedSnackbars = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, type, typeProps } = useSelector(state => state.alert);
  const {message, severity, noBackdrop} = typeProps;

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    dispatch(closeAlert())
  };

  const isOpen = open && type === 'snackbar';

  return <Dialog
    hideBackdrop={noBackdrop}
    onClose={handleClose}
    open={isOpen}
  >
    <Snackbar
      TransitionComponent={Slide}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      key={Math.random()}
      open={open}
    >
      <Alert
        elevation={6}
        onClose={handleClose}
        severity={severity}
        variant="filled"
      >
        <PerfectScrollbar className={classes.message}>
          {message}
        </PerfectScrollbar>
      </Alert>
    </Snackbar>
  </Dialog>
}

CustomizedSnackbars.propTypes = {
  className: PropTypes.string
};

export default CustomizedSnackbars;
